import { Link,useNavigate,  useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { Container,Row,Col,Button, Card  } from "reactstrap";
import defaultAvatar from "../../../../assets/images/default-avatar.png";
import { deleteMerchent, getDocumentsByMarchand, getMarchandById, getVersementByMarchand } from "../services/merchentApi";
import { Select, Skeleton} from "antd";
import FiltrerBusinessModal from "./FiltrerBusinessModal";
import FiltrerVersementModal from "./FiltrerVersementModal";
import { DeleteOutlined, InfoCircleOutlined, WarningOutlined } from "@ant-design/icons";
import ManageMerchent from "./manageMerchant";
import KycMerchent from "../component/rappelValidate.js"
import KycMerchentRejeter from "./kycRejeter.js";
import DocumentCard from "../../../developer/component/detail/DocumentCard.js";
import UploadDocument from "../../../developer/component/uploadDoc.js";
import { addDocKycMerchand } from "../../../merchand/services/merchandApi.js";
import toast from "react-hot-toast";
import "../utils/AddDocVerify.css"
import VersementByMarchand from "./versementMarchand.js";
import BusinessByMarchand from "./businessMerchend.js";
import DocumentMerchand from "./document-merchand.js";
import CountryPerformance from "./country-performance.js";
import DeleteModal from "../../../../common/delete/modalDelete.js";
import { useQueryClient } from "react-query";
const MerchendDetail = ({onRefresh}) => {
  const { id } = useParams();
   const [docType, setDocType] = useState(""); 
  const [ merchant, setMerchant] = useState(null);
  const [activeTab, setActiveTab] = useState("informations");
  const [isManageModalOpen, setIsManageModalOpen] = useState(false);
  const [isKycModalOpen, setIsKycModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState("validate");
  const [isKycRejetModalOpen, setIsKycRejetModalOpen] = useState(false);
  const [selectedMerchent, setSelectedMerchent] = useState(null);
  const [selectedKycMerchent, setSelectedKycMerchent] = useState(null);
  const [filterValues, setFilterValues] = useState(null);
  const [modalState, setModalState] = useState({ type: null, data: null });
  const [isDeleting, setIsDeleting] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = (type, data = null) => {
         setModalState((prevState) => (prevState.type === type ? { type: null, data: null } : { type, data }));
       };
 const handleApplyFilters = (filters) => {
      setFilterValues(filters);
    };
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };
const fetchMerchant = async () => {
  try {
    const data = await getMarchandById(id);
    setMerchant(data);
  } catch (error) {
    console.error("Erreur lors du chargement du marchand :", error);
  }
};

useEffect(() => {
  if (id) {
    fetchMerchant();
  }
}, [id]);
const navigate = useNavigate();
const [merchantDocs, setMerchantDocs] = useState({});
const hasAllDocs =
  merchantDocs?.recto &&
  merchantDocs?.verso &&
  merchantDocs?.rib &&
  merchantDocs?.domicile;
const hasUploadedDocs =
  merchantDocs?.recto ||
  merchantDocs?.verso ||
  merchantDocs?.rib ||
  merchantDocs?.domicile;
 const identityCompleted =
  merchantDocs?.recto &&
  (merchantDocs?.verso || docType === "PASSPORT");

const allCompleted =
  identityCompleted &&
  merchantDocs?.rib &&
  merchantDocs?.domicile;
  const hasRib = !!merchantDocs?.rib;
const hasDomicile = !!merchantDocs?.domicile;
const [loadingDocs, setLoadingDocs] = useState(true);
const fetchDocs = async () => {
  try {
    setLoadingDocs(true);
    const response = await getDocumentsByMarchand(merchant.id);
    setMerchantDocs(response || {});
  } catch (error) {
    console.error("Erreur chargement documents :", error);
  } finally {
    setLoadingDocs(false);
  }
};
useEffect(() => {
  if (merchant?.id) {
    fetchDocs();
  }
}, [merchant?.id]);
const handleDocChange = (key, file) => {
  setDocuments((prev) => ({
    ...prev,
    [key]: file,
  }));
};
const [documents, setDocuments] = useState({
  recto: null,
  verso: null,
  rib: null,
  domicile: null,
});
 const isValidSubmit = () => {
  return (
    documents.recto ||
    documents.verso ||
    documents.rib ||
    documents.domicile
  );
};
 const [isSubmitting, setIsSubmitting] = useState(false);
const handleSubmitDocuments = async () => {
  if (!isValidSubmit()) {
    return toast.error("Veuillez compléter les documents requis");
  }

  setIsSubmitting(true);

  try {
    const files = {
      merchantDocumentType: docType,
      token:currentuser?.token,
      merchandId:id,
      merchantRecto: documents.recto,
      merchantVerso: docType === "CNI" ? documents.verso : null,
      RIB: documents.rib || null,
      Domicile: documents.domicile || null,
    };
    const resp = await addDocKycMerchand(
      files,
    );
    toast.success("Documents soumis avec succès");
   await fetchDocs();
    setDocuments({
      recto: null,
      verso: null,
      rib: null,
      domicile: null,
    });

    setDocType("");

  } catch (err) {
    toast.error("Erreur lors de la soumission");
  } finally {
    setIsSubmitting(false);
  }
};
 const currentuser = JSON.parse(sessionStorage.getItem("authAdmin"));
 const handleDetail = (merchantBusiness) => {
  if (!merchantBusiness || !merchantBusiness.id) {
    console.warn("Developer invalide :",merchantBusiness);
    return;
  }
  navigate(`/business-management/${merchantBusiness.id}`);
};
 const openDeleteConfirmModal = () => {
  setModalState({
    type: "delete",
    data: {
      merchentId: merchant.id,
      merchentName: `${merchant.firstName} ${merchant.lastName}`,
    },
  });
};
  const closeDeleteConfirmModal = () => {
    setModalState({ type: null, data: null });
  };
  const [isMerchantDeleted, setIsMerchantDeleted] = useState(false);
  const queryClient = useQueryClient();
 const handleDelete = async (merchentId) => {
  setIsDeleting(true);

  try {
    await deleteMerchent(merchentId);

    queryClient.invalidateQueries("merchants");

    toast.success("Le marchand a été supprimé avec succès");

    // ✅ vider les données
    setMerchant(null);

    // ✅ afficher écran supprimé
    setIsMerchantDeleted(true);

  } catch (error) {
    toast.error(
      `😔 Erreur lors de la suppression du marchand : ${
        error?.message || error
      }`
    );
  } finally {
    setIsDeleting(false);
    closeDeleteConfirmModal();
  }
};
  if (isMerchantDeleted) {
  return (
    <div
      style={{
        height: "70vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        gap: "16px",
      }}
    >
      <DeleteOutlined
        style={{
          fontSize: "60px",
          color: "#D41C1C",
        }}
      />

      <h2
        style={{
          fontFamily: "Poppins",
          color: "#D41C1C",
          margin: 0,
        }}
      >
        Marchand supprimé
      </h2>

      <p
        style={{
          color: "#667085",
          fontFamily: "Poppins",
        }}
      >
        Ce marchand n'existe plus.
      </p>
    </div>
  );
}
if (!merchant) {
  return (
    <div style={{ padding: '20px' }}>
      <Skeleton.Avatar active size="large" shape="circle" />
      <Skeleton
        active
        title={{ width: '60%' }}
        paragraph={{ rows: 6 }}
        style={{ marginTop: 20 }}
      />
    </div>
  );
}
  return (
   <div className="page-content ">
        <Container fluid >
           <Row >
              <Col className="marchand">
                <Link 
                  to="/marchand" 
                  style={{ textDecoration: "none", color: "#000" }}
                >
                  <span className="marchands">Marchands {">"} </span>
                </Link>
                    {merchant.firstName} {merchant.lastName}
              </Col>
            </Row>
            <Card
              style={{
                padding: "12px",
                border: "1px solid #0000001A",
                borderRadius: "12px",  
                backgroundColor: "#FFFFFF"
                }}
            >
              <div className="merchant-header">
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <img
                        src={ merchant.profilePhoto ||defaultAvatar}
                         alt={`${merchant.firstName} ${merchant.lastName}`}
                        style={{
                            width: 46,
                            height: 46,
                            borderRadius: "50%",
                            objectFit: "cover"
                        }}
                        />
                    </div>
                     <div
                        style={{
                        marginTop: "10px",
                        display: "flex",
                        justifyContent: "space-between",
                        textAlign: "center",
                        }}
                        >
                        <span className="name">{merchant.firstName} {merchant.lastName}</span>
                      </div>
                      <div
                        style={{
                        display: "flex",
                        justifyContent: "space-between",
                        textAlign: "center",
                        }}
                        >
                        <span className="title">Marchand</span>
                        <span
                      onClick={() => {
                          openDeleteConfirmModal();
                        setIsModalOpen(false);
                      }}
                      style={{ display: "flex", alignItems: "start", gap: "8px", cursor: "pointer" }}
                    >
                      <DeleteOutlined
                      style={{fontSize: "20px",color: "#D41C1C",marginLeft:"8px"}}/>
                      
                    </span>

                  </div>
                <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "10px",  
                marginTop: "10px"
              }}>
              <span
                style={{
                  backgroundColor: merchant.active ? "#EBFFEA" : "#FFEFD5",
                  color: merchant.active ? "#349C32" : "#FF7F29",
                  padding: "3px 12px",
                  fontFamily: "Poppins",
                  fontWeight: 400,
                  fontSize: "14px",
                  borderRadius: "999px",
                }}
              >
                <WarningOutlined/> {merchant.active ? "Marchand activé" : "Marchand désactivé"}
              </span>
                <button
                style={{
                  backgroundColor: merchant.active ? " #FFF0F0" : "#EBFFEA",
                  color: merchant.active ? "#D41C1C" : " #349C32",
                  padding: "3px 12px",
                  fontFamily: "Poppins",
                  fontWeight: 400,
                  fontSize: "14px",
                  borderRadius: "4px",
                  border: "none",
                  outline: "none",
                  cursor: "pointer",
                }}
                onClick={() => {
                setSelectedMerchent(merchant);
                setModalMode(merchant.active ? "disable" : "validate");
                setIsManageModalOpen(true);
               
                }}
              >
                {merchant.active ? "Désactiver le compte" : "Réactiver le compte"}
              </button>
              <span style={{color:"#396AFC"}}><InfoCircleOutlined /></span>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "10px",  
                marginTop: "10px"
              }}>
              <span
                style={{
                  backgroundColor: merchant.kycVerified ? "#EBFFEA" : "#FFF0F0",
                  color: merchant.kycVerified ? "#349C32" : "#D41C1C",
                  padding: "3px 12px",
                  fontFamily: "Poppins",
                  fontWeight: 400,
                  fontSize: "14px",
                  borderRadius: "999px",
                }}
              >
                {merchant.kycVerified ? "✓ Kyc activé" : "🚫 Kyc désactivé"}
              </span>
                <button
                style={{
                  backgroundColor: merchant.kycVerified ? " #FFF0F0" : "#EBFFEA",
                  color: merchant.kycVerified ? "#D41C1C" : " #349C32",
                  padding: "3px 12px",
                  fontFamily: "Poppins",
                  fontWeight: 400,
                  fontSize: "14px",
                  borderRadius: "4px",
                  border: "none",
                  outline: "none",
                  cursor: "pointer",
                }}
                onClick={() => {
                setSelectedKycMerchent(merchant);
                setModalMode(merchant.kycVerified ? "disable" : "validate");
                setIsKycModalOpen(true);
               
                }}
              >
                {merchant.kycVerified ? "Désactiver le kyc" : "Activer le kyc"}
              </button>
              <button
              style={{
                backgroundColor: "#D41C1C",
                color: "#FFFFFF",
                padding: "3px 12px",
                fontFamily: "Poppins",
                fontWeight: 400,
                fontSize: "14px",
                borderRadius: "4px",
                border: "none",
                cursor: "pointer",
              }}
              onClick={() => {
                setSelectedKycMerchent(merchant);
                setModalMode("disable");
                setIsKycRejetModalOpen(true);
              }}
            >
              Rejeter le KYC
            </button>
              <span style={{color:"#396AFC"}}><InfoCircleOutlined /></span>
            </div>
            </div>
            
           <div
           className="tabs-container mb-3"
          >
            <div className="merchant-tabs">
          {["informations","Soldes" ,"business", "versements"].map((tab) => (
            <div
              key={tab}
              onClick={() => handleTabClick(tab)}
              style={{
                margin: "0 20px",
                cursor: "pointer",
                color: activeTab === tab ? "#3761FF" : "#00000073",
                fontWeight: activeTab === tab ? 400 : 400,
                fontSize: activeTab === tab ? '16px' : '16px',
                fontFamily: activeTab === tab ? 'Poppins' : 'Poppins',
                fontStyle: activeTab === tab ? 'normal' : 'normal',
                position: "relative",
                paddingBottom: "0px",
              }}
            >
              {tab.charAt(0).toUpperCase() + tab.slice(1)}
              {activeTab === tab && (
                <div
                  style={{
                    height: "2px",
                    backgroundColor: "#3761FF",
                    width: "100%",
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                  }}
                />
              )}
            </div>
          ))}
            </div>
            </div>
             <div className="content-container">
                {activeTab === "informations" && (
              <>
              <Row className="mt-4 px-3">
                <Col md={6} className="mb-4">
                <label className="label">N° Téléphone</label>
                    <input
                    type="text"
                    value={merchant?.phoneNumber || "---"}
                    className="merchant-input"
                    style={{
                    backgroundColor: "#F8F8F8",
                    border: "none",
                    padding: "10px",
                    fontSize: "16px",
                    color: "#2A2A2A",
                    fontWeight:400,
                     fontFamily:'Poppins'
                }}
                    />
                </Col>
                <Col md={6} className="mb-4">
                <label className="label">Email</label>
                    <input
                    type="text"
                    value={merchant?.email || "---"}
                    className="merchant-input"
                    style={{
                    backgroundColor: "#F8F8F8",
                    border: "none",
                    padding: "10px",
                    fontSize: "16px",
                    color: "#2A2A2A",
                    fontWeight:400,
                   fontFamily:'Poppins'
                }}
                    />
                </Col>
                </Row>
                <Row className="px-3">
                <Col md={6} className="mb-4">
                <label className="label">Pays</label>
                    <input
                    type="text"
                    value={merchant?.country || "---"}
                    className="merchant-input"
                    style={{
                    backgroundColor: "#F8F8F8",
                    border: "none",
                    padding: "10px",
                    fontSize: "16px",
                    color: "#2A2A2A",
                    fontWeight:400,
                    fontFamily:'Poppins'
                }}
                    />
                </Col>
                <Col md={6} className="mb-4">
                <label className="label">Adresse</label>
                    <input
                    type="text"
                    value={merchant?.adresse|| "---"}
                    className="merchant-input"
                    style={{
                    backgroundColor: "#F8F8F8",
                    border: "none",
                    padding: "10px",
                    fontSize: "16px",
                    color: "#2A2A2A",
                    fontWeight:400,
                    fontFamily:'Poppins'
                }}
                    />
                </Col>
                </Row>
                <Row className="px-3">
                <Col md={6} className="mb-4">
                <label className="label">Nombre de business</label>
                    <input
                    type="number"
                    value={merchant?.totalDeveloperAccounts|| "0.0"}
                    className="merchant-input"
                    style={{
                    backgroundColor: "#F8F8F8",
                    border: "none",
                    padding: "10px",
                    fontSize: "16px",
                    color: "#2A2A2A",
                    fontWeight:400,
                    fontFamily:'Poppins'
                }}
                    />
                </Col>
                <Col md={6} className="mb-4">
                <label className="label">Chiffre d’affaire annuel</label>
                    <input
                    type="number"
                     value={merchant?.totalAvailableBalance|| "0.0"}
                    className="merchant-input"
                    style={{
                    backgroundColor: "#F8F8F8",
                    border: "none",
                    padding: "10px",
                    fontSize: "16px",
                    color: "#2A2A2A",
                    fontWeight:400,
                     fontFamily:'Poppins'
                }}
                    />
                </Col>
                </Row>
                <Row className="px-3">
                <Col md={6} className="mb-4">
                <label className="label">Nombre de transaction</label>
                    <input
                    type="number"
                    value={merchant?.totalTransactions|| "0.0"}
                    className="merchant-input"
                    style={{
                    backgroundColor: "#F8F8F8",
                    border: "none",
                    padding: "10px",
                    fontSize: "16px",
                    color: "#2A2A2A",
                    fontWeight:400,
                    fontFamily:'Poppins'
                }}
                    />
                </Col>
                <Col md={6} className="mb-4">
                <label className="label">Solde disponible</label>
                    <input
                    type="number"
                     value={merchant?.totalAvailableBalance|| "0.0"}
                    className="merchant-input"
                    style={{
                    backgroundColor: "#F8F8F8",
                    border: "none",
                    padding: "10px",
                    fontSize: "16px",
                    color: "#2A2A2A",
                    fontWeight:400,
                     fontFamily:'Poppins'
                }}
                    />
                </Col>
                </Row>
                 <Row className="px-3">
                  <Col md={12} className="mb-4">
                <label className="label">API KEY</label>
                   <div className="fake-input">
                <span>{merchant?.apiKey?.substring(0, 12)}</span>
                <span className="blurred">{merchant?.apiKey?.substring(12) || "---"}</span>
              </div>
                </Col>
                </Row>
                 <Row className="px-3">
                  <Col md={12} className="mb-4">
                <label className="label">API TOKEN</label>
                   <div className="fake-input">
                <span>{merchant?.apiKey?.substring(0, 12)}</span>
                <span className="blurred">{merchant?.apiKey?.substring(12) || "---"}</span>
              </div>
                </Col>
                </Row>
                <Row className="px-3">
                  <Col md={12} className="">
                  <label className="labem">Documents KYC</label>
                  <DocumentMerchand
                  merchant={merchant}
                  merchantDocs={merchantDocs}
                  loadingDocs={loadingDocs}
                  documents={documents}
                  setDocuments={setDocuments}
                  docType={docType}
                  setDocType={setDocType}
                  handleSubmitDocuments={handleSubmitDocuments}
                  isSubmitting={isSubmitting}
                />
                </Col>
                </Row>
                </>
                )}
              
    {activeTab === "business" && (
    <BusinessByMarchand  id={merchant?.id}/>
    )}        
    {activeTab === "versements" && (
     <VersementByMarchand id={merchant?.id} />
    )}
    {activeTab === "Soldes" && (
  <>
  <CountryPerformance id={merchant?.id}/>
  </>
  )}
  </div>
       {modalState.type === "business-filtrer" && (
              <FiltrerBusinessModal
                isOpen={modalState.type === "business-filtrer"}
                toggle={() => openModal("business-filtrer", modalState.data)}
                 onApply={handleApplyFilters}
            
              />
            )}
         {modalState.type === "versement-filtrer" && (
              <FiltrerVersementModal
                isOpen={modalState.type === "versement-filtrer"}
                toggle={() => openModal("versement-filtrer", modalState.data)}
                 onApply={handleApplyFilters}
            
              />
            )}
        {isManageModalOpen && (
        <ManageMerchent
          modal={isManageModalOpen}
          setModal={setIsManageModalOpen}
          toggle={() => setIsManageModalOpen(false)}
          selectedMerchent={selectedMerchent}
          mode={modalMode}
          onSuccess={fetchMerchant}
        />
      )}
      {isKycModalOpen && (
        <KycMerchent
          modal={isKycModalOpen}
          setModal={setIsKycModalOpen}
          toggle={() => setIsKycModalOpen(false)}
          selectedMerchent={selectedKycMerchent}
          mode={modalMode}
          onSuccess={fetchMerchant}
        />
      )}
      {isKycRejetModalOpen && (
        <KycMerchentRejeter
          modal={isKycRejetModalOpen}
          setModal={setIsKycRejetModalOpen}
          toggle={() => setIsKycRejetModalOpen(false)}
          selectedMerchent={selectedKycMerchent}
          mode={modalMode}
          onSuccess={fetchMerchant}
        />
      )}
        {modalState.type === "delete" && (
            <DeleteModal
              isOpen={true}
              title={`le marchand ${modalState.data.merchentName}`}
              loading={isDeleting}
              onCancel={closeDeleteConfirmModal}
              onConfirm={() => handleDelete(modalState.data.merchentId)}
            />
          )}
      </Card>
    </Container>
        
    </div>
  );
};

export default MerchendDetail;
